import React from "react";
import { useNavigate } from "react-router-dom";
import { FiBriefcase, FiMapPin, FiBookmark, FiShare2 } from "react-icons/fi";
import { FaStar } from "react-icons/fa";
import "../styles/JobCard.css";

function timeAgo(dateStr) {
  const now = new Date();
  const d = new Date(dateStr);
  const seconds = Math.floor((now - d) / 1000);
  const units = [
    { name: "year", sec: 31536000 },
    { name: "month", sec: 2592000 },
    { name: "week", sec: 604800 },
    { name: "day", sec: 86400 },
    { name: "hour", sec: 3600 },
    { name: "minute", sec: 60 },
  ];
  for (let u of units) {
    const val = Math.floor(seconds / u.sec);
    if (val >= 1) return `${val} ${u.name}${val > 1 ? "s" : ""} ago`;
  }
  return "Just now";
}

export default function JobCard({ job, layout = "grid" }) {
  const navigate = useNavigate();

  //added on 19.12.2025

  const saveJob = (job) => {
    const savedJobs = JSON.parse(localStorage.getItem("savedJobs")) || [];
  
    const exists = savedJobs.find(j => j.id === job.id);
    if (!exists) {
      savedJobs.push(job);
      localStorage.setItem("savedJobs", JSON.stringify(savedJobs));
    }
  };

  return (
    <article className={`pjob-card ${layout === "list" ? "horizontal" : "vertical"}`}>
      <div className="pjob-main">
        <div className="ptitle-row">
          <div className="ptitle-left">
            <h3 className="pjob-title">{job.title}</h3>
            <div className="pcompany">{job.company}</div>
          </div>

          {job.companyLogo ? <img className="plogo" src={job.companyLogo} alt={`${job.company} plogo`} /> : null}
        </div>

        <div className="pmeta-row">
          <div className="pmeta-item"><FiBriefcase className="piconn" /> <strong>{job.yoe}</strong></div>
          <div className="pmeta-item"><FiMapPin className="piconn" /> <span>{job.location}</span></div>
          {job.salary && <div className="pmeta-item"><span className="psalary-icon">₹</span> <span>{job.salary}</span></div>}
        </div>

        <p className="pshort-desc">{job.description}</p>

        <div className="pskills-row">
          {job.skills.map((s, i) => (
            <div className="pskill" key={s + i}>
              <FaStar className="pstar" /> <span>{s}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="pjob-footer">
        <div className="pposted">
          Posted {timeAgo(job.postedAt)} by <span className="pposted-by">{job.postedBy}</span>
        </div>

        <div className="paction-row">
          <button className="picon-btn" aria-label="save" title="Save" onClick={() => saveJob(job)}>
            <FiBookmark />
          </button>

          <button className="picon-btn" aria-label="share" title="Share">
            <FiShare2 />
          </button>

          <button
            className="papply-btn"
            onClick={() => navigate(`/job/${job.id}`)}
            aria-label="Apply"
          >
            View
          </button>
        </div>
      </div>
    </article>
  );
}
